import {
  useRecipeGrid,
  applyFilters,
  updateFilters,
} from '@/components/RecipeGrid/RecipeGridProvider';
import { SortAndFilter } from '@/components/SortAndFilter';
import { SortItemType, useSort } from '@/hooks/useSort';
import { FilterMenu } from '@/components/FilterMenu';
import { useEffect, useState } from 'react';
import { Title } from '@/components/Typography';

type Props = {
  title?: string;
  searchItemLabels: Record<string, string>;
};

export const RecipeGridHeader = ({ title, searchItemLabels }: Props) => {
  const { state, dispatch } = useRecipeGrid();
  const { getAvailableSortMethods } = useSort(SortItemType.ANY);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    if (state.facets) {
      updateFilters(state.facets, searchItemLabels, state.facetFilters ?? [], dispatch);
    }
  }, [state.facets, state.facetFilters, searchItemLabels, dispatch]);

  if (state.recipes.length === 0 && !state.loading) {
    return null;
  }

  return (
    <>
      <FilterMenu
        isOpen={showFilter}
        title={searchItemLabels?.filters}
        filters={state.filters ?? []}
        onClose={() => {
          setShowFilter(false);
        }}
        onApplyFilters={(newFilters) => applyFilters(newFilters, dispatch)}
        labels={searchItemLabels}
        totalResults={state.totalResults}
      />
      <div className="flex flex-col md:flex-row justify-center md:justify-between w-full mb-10">
        <div className="flex justify-center md:justify-start md:mb-0 mb-3">
          {title && (
            <Title tag="h2" type="sm">
              {title}
            </Title>
          )}
        </div>
        <div>
          <SortAndFilter
            currentCount={state.totalResults}
            labels={searchItemLabels}
            selectedSort={state.sortMethod}
            options={getAvailableSortMethods().map((method) => ({
              label: searchItemLabels?.[`sort_${method}`] || method,
              value: method,
            }))}
            onSort={(method) => dispatch({ type: 'SET_SORT_METHOD', method })}
            onFilter={() => setShowFilter(true)}
          />
        </div>
      </div>
    </>
  );
};
